import { space } from 'containers/app/schema'

export const result = {
  spaces: [space],
}
